<template>
  <div class="filter_bar">
    <!--Bar-->
    <div class="flex flex-between flex-vertical-center">
      <!--Left Bar-->
      <div class="flex">
        <slot name="leftBar"></slot>
      </div>

      <!--Right Bar-->
      <div class="flex flex-end">
        <!--Filter Button-->
        <div class="flex flex-vertical-center">
          <p v-if="filterText" class="filter_text">{{ filterText }}</p>

          <button-outlined
            icon-left="filter"
            @click="openFilterSidebar = true"
            is-short
          >Filters
          </button-outlined>
        </div>

        <!--Refresh Button-->
        <template v-if="hasRefreshButton">
          <button-outlined
              @click="refresh"
              color="is-secondary"
              class="ml-100"
              is-short
          >Refresh
          </button-outlined>
        </template>

        <slot name="rightBar"></slot>
      </div>
    </div>

    <!--Sidebar-->
    <b-sidebar
      type="is-white"
      fullheight
      :overlay="false"
      right
      v-model="openFilterSidebar"
    >
      <div class="sidebar_main">
        <div class="sidebar_main--header">
          <h4>{{ label }}</h4>
        </div>

        <div class="sidebar_main--content">
          <slot></slot>
        </div>

        <div class="sidebar_main--footer">
          <div class="flex">
            <button-outlined
              class="mr-100"
              color="is-secondary"
              v-if="hasApplyFilterButton"
              @click="openFilterSidebar = false"
            >Close</button-outlined>

            <button-link @click="reset">reset</button-link>
          </div>

          <button-outlined v-if="hasApplyFilterButton" @click="apply">Apply Filters</button-outlined>
          <button-outlined
            v-else
            color="is-secondary"
            @click="openFilterSidebar = false"
          >Close</button-outlined>
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
export default {
  name: "FilterBar",
  props: {
    label: {
      type: String,
      default: ""
    },
    filterText: String,
    hasApplyFilterButton: {
      type: Boolean,
      default: false,
    },
    apply: {
      type: Function,
      default: () => {}
    },
    reset: {
      type: Function,
      required: true
    },
    hasRefreshButton: {
      type: Boolean,
      default: false,
    },
    refresh: {
      type: Function,
      default: () => {
      }
    },
  },
  data() {
    return {
      openFilterSidebar: false,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.filter_bar {
  width: 100%;
  padding: 10px 0;
}

.filter_text {
  margin-right: 12px;
  font-size: 0.8rem;
  font-style: italic;
}

.filter_label {
  padding: 1rem;
  color: $text-light;
  font-size: 0.75rem;
  text-transform: uppercase;
}

.filter_buttons {
  padding: 0 18px 18px;
}

.sidebar_main {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &--header {
    padding: 10px;
  }

  &--content {
    flex-grow: 1;
    overflow-y: scroll;
    padding: 10px 0;
    border-top: 1px solid $border;
    border-bottom: 1px solid $border;
  }

  &--footer {
    padding: 8px 15px;
    display: flex;
    justify-content: space-between;
  }
}
</style>
